export const PricingCardGroup = function ({ props, children }) {
  return <div>{children}</div>;
};
